<template>
  <div class="course-card" :class="{ selected: isSelected }">
    <img
      src="../../assets/images/course.png"
      :alt="course.title"
      class="course-logo"
    />
    <h3 class="course-title">{{ course.title }}</h3>
    <p class="course-desc">
      {{ course.description }}
    </p>
    <button :id="`select-course-btn-${course.id}`" class="select-btn" @click="selectCourse">
      {{ $t(isSelected ? "reservation.unselect" : "reservation.select") }}
    </button>
  </div>
</template>

<script>
import GlobalMixin from "../../GlobalMixin";

export default {
  name: "CourseCard",
  mixins: [GlobalMixin],
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxSelectedCourses: 2,
    };
  },
  methods: {
    /**
     * Select course, emits an event and change button Text
     */
    selectCourse() {
      if (this.isSelected)
        return this.$emit("select-course", this.course.id, true);
      if (this.selectedCourses.length === this.maxSelectedCourses)
        return this.showAlert(
          `You can choose only up to ${this.maxSelectedCourses} courses!`,
          "error"
        );
      this.$emit("select-course", this.course.id);
    },
  },
  computed: {
    /**
     * Get all selected courses ids
     */
    selectedCourses() {
      return this.$store.getters.GET_SELECTED_COURSES;
    },

    /**
     * Check if course is selected or not
     */
    isSelected() {
      return this.selectedCourses.includes(this.course.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.course-card {
  &.selected {
    background: #e7f5e8;
    outline: 2px solid $green;
  }
  padding: 16px 16px 20px;
  outline: 1px solid #b4bbc5;
  border-radius: 8px;
  background: $white;
  font-family: $font-family;
  font-style: normal;
  display: flex;
  flex-direction: column;
  .course-logo {
    border-radius: 8px;
    width: 100%;
    object-fit: fill;
    aspect-ratio: 224/205;
  }
  .course-title {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    color: #061c3d;
    margin-top: 16px;
  }
  .course-desc {
    margin-bottom: 8px;
    font-weight: 300;
    font-size: 0.75rem;
    line-height: 1rem;
    color: $description;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .select-btn {
    margin-top: auto;
    padding: 8px 0;
    background: $green;
    border-radius: 8px;
    color: $white;
    font-size: 1rem;
    line-height: 1.5rem;
    &:hover {
      background: $hover-green;
    }
  }
}
@media all and (max-width: 1440px) and (min-width: 768px) {
  .course-card {
    padding: 16px 13px 20px;
  }
}

@media all and (max-width: 768px) {
  .course-card {
    padding: 8px;
    .course-title {
      margin: 4px 0;
      font-size: 12px;
      line-height: 15px;
    }
    .course-desc {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 4px;
    }
    .select-btn {
      padding: 4px 0;
      font-size: 12px;
      line-height: 15px;
    }
  }
}
</style>
